export default {
  path: 'settings/construction-sites',
  name: 'TemporaryRegulationsConstructionSites',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/ConstructionSitesIndex.vue')
}
